import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './styles/chatbot.module.css';
import Header from '@/components/chatbot/Layout/Header';
import Signature from '@/components/chatbot/Layout/Signature';
import ChatbotContent from '@/components/chatbot/Layout/ChatbotContent';
import { AnimatePresence, motion } from 'framer-motion';

const Chatbot = ({ hideCloseBtn }) => {
  const { animTransition, isChatbotVisible, settings, company, isDirectLink } = useSelector(
    state => ({
      isChatbotVisible: state.chatbotVisibility.isVisible,
      animTransition: state.chatbotVisibility.animTransition,
      settings: state.chatbotDetails.settings,
      company: state.chatbotDetails.company,
      isDirectLink: state.chatbotDetails.isDirectLink,
    }),
  );

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && (isChatbotVisible || !animTransition)) {
      setDimensions({
        width: ref.current.offsetWidth,
        height: ref.current.offsetHeight,
      });
    }
  }, [isChatbotVisible, animTransition]); // Ensure this effect runs when the component mounts

  const variants = {
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
    hidden: {
      opacity: 0,
      scale: 1,
      x: 0,
      y: 0,
      transition: {
        duration: 0.5,
      },
      transitionEnd: {
        scale: 0,
        x: settings?.position === 'left' ? (dimensions.width ? 25 - dimensions.width / 2 : -175) : (dimensions.width ? dimensions.width / 2 - 25 : 200),
        y: dimensions.height ? dimensions.height / 2 - 25 : 300,
      },
    },
  };

  return (
    <AnimatePresence>
      <motion.div
        ref={ref}
        initial={'hidden'}
        animate={animTransition ? 'visible' : 'hidden'}
        variants={variants}
        className={`${styles.wrapper} ${isDirectLink ? styles.direct_link : ''} ${
          settings?.position === 'left' ? styles.left : styles.right
        }`}
        onClick={e => e.stopPropagation()}
        style={{
          pointerEvents: animTransition ? 'auto' : 'none',
        }}
      >
        <Header hideCloseBtn={hideCloseBtn} />
        <ChatbotContent />
        {company?.features?.hide_chatbot_brand ? null : <Signature />}
      </motion.div>
      )
    </AnimatePresence>
  );
};

Chatbot.propTypes = {
  hideCloseBtn: PropTypes.bool,
};

export default Chatbot;